namespace Gordic.Epk.WebControls {

    /**
     * Dialog přípravy vyřízení žádosti ze seznamu na subtasku Vše
     * 
     * @author thazmuka
     * @since 482.1.0.339
     */
    export class PripravaVyrizeniSubtaskVseDlg {

        /** otevřít dialog */
        public open(cnt: any, rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {

            var gcontent: GContent<GEpkDbParamsNew> = cnt;
            var element = $("<div>");
            var commandBar = this.createCommandBar(gcontent);

            var requests = this.filterRows(rows);
            this.createForm(requests, element);

            this.createModalWindow(gcontent, element, commandBar);

        }

        private filterRows(rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            var array: number[] = []; //typ_pozad_pod - číslo požadavku
            for (let index = 0; index < rows.length; index++) {
                var row = rows[index];
                // přidat typ požadavku k hromadnému vyřízení pokud je definován a není prázdný a
                // zároveň to není požadavek Splnit(60), Rozhodnout(100), která jsou pro Ukrajinu
                // 13.11.2019 (thazmuka)
                if (row.typ_poz_txt != null && row.typ_pozad_pod != null && row.typ_pozad_pod !== 60 && row.typ_pozad_pod !== 100) {
                    array.push(row.typ_pozad_pod)
                }
            }
            // vyfiltrování duplikátů
            let filter_method = (array) => array.filter((v, i) => array.indexOf(v) === i);
            return filter_method(array);
        }

        private createModalWindow(gcontent: GContent<any>, element: JQuery<HTMLElement>, commandBar: MenuParams[]) {
            gcontent.dialogs.showModalWindow(element, null, {
                width: 800,
                height: 350,
                title: "jres:32000502", //RC 32000502 : Hromadné vyřízení
                commandBar: commandBar
            });
        }

        private createCommandBar(cnt: any) {

            var gcontent: GContent<GEpkDbParamsNew> = cnt;
            var menuParams: MenuParams[] = [];

            menuParams.push({
                action: gcontent.actions.add(new GAction({
                    name: "actZavritPripravaHromadneVyrizeniDlg",
                    caption: "jres:32000023", //RC 32000023 : Zavřít
                    run: function (ev: any, ctx) {
                        this.content.tryCloseAllSignificants();
                    }
                }))
            });

            menuParams.push({
                action: gcontent.actions.add(new GAction({
                    name: "actVyriditPripravaHromadneVyrizeniDlg",
                    caption: "jres:32000504", //RC 32000504 : Vyřídit
                    run: (ev: any, ctx) => {
                     
                    }
                }))
            });

            return menuParams;
        }

        private createForm(numbers: number[], element: JQuery<HTMLElement>) {

            var form = $("<div class='form_class'>").appendTo(element);

            var Form = new Gordic.Forms.Form({
                name: "Form",
                layoutDescriptor: "L2M2S1, L-4-8-0, M-4-8-0, S-12-12-0, breaks-300-400"
            });

            var data = [
                { value: 'podepsat', label: 'jres:26265056' },              //RC 26265056 : Podepsat
                { value: 'schvalit', label: 'jres:26265058' },              //RC 26265058 : Schválit
                { value: 'podepsat_schvalit', label: 'jres:32000065' },     //RC 32000065 : Podepsat a schválit
                { value: 'posoudit', label: 'jres:26265059' },              //RC 26265059 : Posoudit
                { value: 'vzitnavedomi', label: 'jres:32000207' }           //RC 32000207 : Vzít na vědomí
            ];

            var dataView = new Gordic.Data.View(data);

            Form
                .addRow("jres:32000503") //RC 32000503 : Typy požadavků
                .addField("gselectbox", {
                    itemWidth: " ",
                    data: dataView,
                    name: "typ_pozad_pod",
                    multi: false,
                    list: true,
                    itemTemplate: (value) => {
                        if (value != null)
                            return value.label;
                    }
                })

            form.gform("createFrom", Form);

        }


    }

}